import { useQuery } from "@tanstack/react-query";
import { getForecastPredictabilitySummary } from "./api";

// Default to 30 days, matching the trailing window the other cost-control dashboards use; the
// chart toggle lets a CFO widen to 60 or 90.
export const DEFAULT_HORIZON = 30;

// useForecastPredictability loads the forecast summary for the given horizon
// (30 | 60 | 90, defaults to 30).
export function useForecastPredictability(horizon = DEFAULT_HORIZON) {
  return useQuery({
    queryKey: ["forecast-predictability-summary", horizon],
    queryFn: () => getForecastPredictabilitySummary({ horizon }),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: "always",
  });
}
